// Las barras de las fechas, puestas solas mientras se teclea.
//
// Lissette, 2026-08-25, de parte de una agente: *"cuando se escriban fechas en
// el sistema que aparezcan automaticamente los / separadores de fecha"*.
//
// `DateField` ya dejaba escribir la fecha a mano (Lissette 2026-06-19 #7),
// pero habia que teclear las barras una por una. Ocho digitos y dos barras en
// cada fecha, muchas veces al dia.
//
// Vive en su propio modulo, sin dependencias, para poder probarlo desde
// `npm test` del backend: los componentes .jsx no se pueden importar fuera de
// un navegador (arrastran la autenticacion, que necesita `window`).

/**
 * Reformatea lo que se acaba de teclear en un campo de fecha a mm/dd/aaaa.
 *
 * @param {string} crudo  El valor del input DESPUES de la pulsacion.
 * @param {boolean} borrando  Si la pulsacion quito caracteres en vez de anadir.
 * @returns {string} El texto ya con sus barras.
 *
 * Reglas, y el porque de cada una:
 *
 *  - **Borrando no se toca nada.** Si al borrar se volviera a poner la barra,
 *    el cursor se quedaria atascado en ella para siempre: quitas la barra, el
 *    formateador la repone, y no hay forma de seguir hacia atras.
 *
 *  - **Una barra escrita a mano CIERRA el grupo.** Quien teclea "8/25/2026"
 *    quiere el mes 08, no el 82. Sin esto, la barra se tragaba y el siguiente
 *    digito se pegaba al 8.
 *
 *  - **Solo se rellena con cero el grupo ya cerrado.** Mientras escribes "8/2"
 *    ese 2 puede ser el dia 2 o el 25; convertirlo en "02" a medias seria
 *    decidir por el que escribe.
 *
 *  - **La barra se pone al COMPLETAR el grupo**, no antes: asi el siguiente
 *    digito cae solo en su sitio y no hay que pulsarla.
 */
export function maskDateTyping(crudo, borrando) {
  const s = String(crudo == null ? '' : crudo);
  if (borrando) return s;

  // Una fecha pegada en formato de base de datos (aaaa-mm-dd) se reconoce y se
  // da la vuelta. Copiar una fecha de un campo a otro es de lo mas normal, y
  // sin esto "2026-08-25" acabaria como "20/26/0825".
  const iso = /^\s*(\d{4})-(\d{2})-(\d{2})\s*$/.exec(s);
  if (iso) return `${iso[2]}/${iso[3]}/${iso[1]}`;

  const grupos = s.split('/');
  const soloDigitos = (x) => String(x || '').replace(/\D/g, '');
  const mm = soloDigitos(grupos[0]).slice(0, 2);
  const dd = soloDigitos(grupos[1]).slice(0, 2);
  const aa = soloDigitos(grupos[2]).slice(0, 4);
  // `grupos.length > 1` = hay una barra DESPUES del mes, o sea el que escribe
  // ya lo dio por terminado.
  const mmOk = grupos.length > 1 && mm ? mm.padStart(2, '0') : mm;
  const ddOk = grupos.length > 2 && dd ? dd.padStart(2, '0') : dd;

  const d = (mmOk + ddOk + aa).slice(0, 8);
  if (!d) return '';

  let out = d.slice(0, 2);
  if (d.length > 2) out += '/' + d.slice(2, 4);
  if (d.length > 4) out += '/' + d.slice(4, 8);
  if (d.length === 2 || d.length === 4) out += '/';
  return out;
}
